import { createFileRoute } from "@tanstack/react-router";
import { NodesPage } from "../../../features/infrastructure/nodes";

export const Route = createFileRoute("/_authed/$org/infrastructure/nodes/")({ component: Page });

function Page() {
  const { org } = Route.useParams();
  return <NodesPage org={org} />;
}
